import Celebi from './Celebi';
import image from './preview.png';

export const Image = image;
export default Celebi;
